import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "openStack",
  "use": "openStack-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"openStack\"><path d=\"M12.5 12.01c0 .27-.22.49-.49.49H5.99a.49.49 0 01-.49-.49v-.21H2v3.38c0 .45.37.82.82.82h12.36c.45 0 .82-.37.82-.82V11.8h-3.5v.21zm-7-4.41H2v2.8h3.5V7.6zM15.18 2H2.82c-.45 0-.82.37-.82.82V6.2h3.5v-.21c0-.27.22-.49.49-.49h6.03c.27 0 .49.22.49.49v.21h3.5V2.82a.839.839 0 00-.83-.82zm-2.68 8.4H16V7.6h-3.5v2.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol